jQuery(document).ready(function($){

    var hash = window.location.hash;
    var enviroment;

    if ( hash == '#Inomhus' ) {
        enviroment = 1;
        setTimeout(function() {
            $('#wpgmza_filter_select').val(enviroment).change();
        }, 1500);

    }
    else if ( hash == '#Utomhus' ) {
        enviroment = 2;
        setTimeout(function() {
            $('#wpgmza_filter_select').val(enviroment).change();
        }, 1500);
    }
	
});
